import { Img } from "containers/Manual/components/content/Image";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";

export const YEAR = () => {
  return (
    <CardSection id="YEAR" title="YEAR">
      <Paragraph>날짜에서 연도를 추출합니다.</Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>YEAR(DATETIME)</Paragraph>
        <Ul>
          <Li>
            <b>DATETIME</b>은 연도를 추출하려는 날짜입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>Year(`DATE`)</Paragraph>
        <Img src="computeYaer" />
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          제공하는 <b>DATETIME</b>은 날짜/시간 객체, 날짜/시간 객체를 포함하는
          열 또는 날짜/시간 객체를 반환하는 함수여야 합니다.
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
